<script type="text/javascript">
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";

	import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';
	import IconButton, {Icon} from "@smui/icon-button"
	import Menu, {SelectionGroup, SelectionGroupIcon} from "@smui/menu";
	import {Anchor} from "@smui/menu-surface";

	import AppStore from "../../AppStore";
	import MapLayer from "../../Map/Enums/MapLayer";
	import MapStore from "../../Map/Store";

	import RangeRing from "./RangeRing/RangeRing";
	import RoutePlot from "./RoutePlot"
	import RoutePlottingStore from "./RoutePlottingStore";
	import RoutePlotComponent from "./RoutePlot.svelte";

	import { CtrlKeyDown, ShiftKeyDown, AltKeyDown } from "../../Stores/userInput.js";

	let contextMenu = null;

	let map = null;;
	let routePlots = RoutePlottingStore.inputs.plots;
	let lastUpdated = RoutePlottingStore.meta.lastUpdated;

	$: {
		$lastUpdated;
		RoutePlottingStore.helpers.rebuildGeoJSON();
	}

	let movingPlotIndex = -1;
	let movingPointIndex = -1;
	let onPointMove = (e) => {
		if (movingPlotIndex >= 0 && movingPointIndex >= 0) {
			$routePlots[movingPlotIndex].setPointPosition(movingPointIndex, e.lngLat.lng, e.lngLat.lat);
		}
	}

	let onUp = (e) => {
		$routePlots[movingPlotIndex].recalculateDistance();
		movingPlotIndex = -1;
		movingPointIndex = -1;
		RoutePlottingStore.helpers.rebuildGeoJSON();

		// Unbind mouse/touch events
		map.off('mousemove', onPointMove);
		map.off('touchmove', onPointMove);
	}

	let findClosestPlotIndex = (lng, lat) => {
		let closestIndex = -1;
		let closestDistance = RoutePlot.MAX_DISTANCE;
		for(let i = 0; i < $routePlots.length; i++) {
			let distSq = $routePlots[i].findClosestDistanceSquaredTo(lng, lat);
			if (distSq < closestDistance) {
				closestIndex = i;
				closestDistance = distSq;
			}
		}
		return closestIndex;
	}



	MapStore.meta.initialised.subscribe((initialised) => {
		if (initialised) {
			map = MapStore.helpers.getMap();

			map.on('mouseenter', MapLayer.ROUTEPLOT_POINTS, (e) => {
		  		map.getCanvas().style.cursor = 'move';
			});
			map.on('mousemove', MapLayer.ROUTEPLOT_POINTS, (e) => {
				map.getCanvas().style.cursor = 'move';
			});
			map.on('mouseleave', MapLayer.ROUTEPLOT_POINTS, function() {
				map.getCanvas().style.cursor = MapStore.helpers.getDefaultCursor();
			});

			let mouseDown = (e) => {
				e.preventDefault();
				if (get(RoutePlottingStore.meta.visible)// && 
					//get(RoutePlottingStore.meta.activeTab) === "Route Plotting"
					) 
				{
					if (movingPlotIndex === -1 && movingPointIndex === -1 && e.features[0] != null) {

						let lng = e.features[0].geometry.coordinates[0];
						let lat = e.features[0].geometry.coordinates[1];
						let closestIndex = findClosestPlotIndex(lng,lat);
						if (closestIndex >= 0) {
							const rs = $routePlots[closestIndex].findClosestPointByLngLat(e.features[0].geometry.coordinates[0], e.features[0].geometry.coordinates[1]);
							if (rs != null) {
								movingPlotIndex = closestIndex;
								movingPointIndex = rs;

								map.on('mousemove', onPointMove);
								map.on('touchmove', onPointMove);
								map.once('mouseup', onUp);
								map.once('touchend', onUp);
							}
						}
					}

				}
			};
			map.on('mousedown', MapLayer.ROUTEPLOT_POINTS, mouseDown);
			map.on('touchstart', MapLayer.ROUTEPLOT_POINTS, mouseDown);

			// Map behaviours
			map.on('click', (e) => {
				if (get(RoutePlottingStore.meta.visible) && 
					get(RoutePlottingStore.meta.activeTab) === "Route Plotting" &&
					e.type === "click") {

					// Find which routeplot is closest to the new point.
					let closestIndex = findClosestPlotIndex(e.lngLat.lng, e.lngLat.lat);
					if ($routePlots.length == 0 && ($CtrlKeyDown || $AltKeyDown)) {
						RoutePlottingStore.actions.add();
					}
					if ($routePlots.length == 1 && $routePlots[0].pointsLength === 0) {
						closestIndex = 0;
					}
					if (closestIndex >= 0) {
						if ($CtrlKeyDown) {
							$routePlots[closestIndex].addPointAt(e.lngLat.lng, e.lngLat.lat);
							e.preventDefault();
						}
						if ($AltKeyDown) {
							$routePlots[closestIndex].addPointBetweenAt(e.lngLat.lng, e.lngLat.lat);
							e.preventDefault();
						}
					}
				}
			});
			map.on('contextmenu', MapLayer.ROUTEPLOT_POINTS, (e) => { // Right click
				for (let i = 0; i < $routePlots.length; i++) {
					const index = $routePlots[i].findClosestPointByLngLat(e.lngLat.lng, e.lngLat.lat);
					if (index >= 0) {
						let point = $routePlots[i].getPointAt(index);
						$routePlots[i].removePointByLngLat(point.position.lng, point.position.lat);
						break;
					}
				}
			});
		}
	});

</script>

<div class='routeplotting'>
	<MenuItem title={"Route Plotting"} materialIcon={"square_foot"}>
		<div slot="context-menu">
			<IconButton class="material-icons" on:click={()=>{
				if ($routePlots.length == 0) {
					RoutePlottingStore.actions.add();
				}
				else {
					contextMenu.setOpen(true);
				}
			}}>{#if $routePlots.length == 0}add{:else}edit{/if}</IconButton>
			<div style="left:-115px;">
				<Menu bind:this={contextMenu} anchorCorner="TOP_RIGHT">
					<List>
						<Item on:SMUI:action={()=>{RoutePlottingStore.actions.add();}}><Text>Add Route</Text></Item>
						<Item on:SMUI:action={()=>{RoutePlottingStore.actions.clearAll();}}><Text>Clear All</Text></Item>
					</List>
				</Menu>
			</div>
		</div>
		{#each $routePlots as routePlot, index (routePlot)}
			<RoutePlotComponent routePlot={routePlot} index={index} />
		{/each}
		{#if $routePlots.length === 0}
			<p>Add a route to get started...</p>
		{/if}

	</MenuItem>
</div>
